module.exports = __webpack_public_path__ + "img/analysis-income.52ee6d64.svg";